import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LocalStorageService} from '@services/local-storage.service';
import {Observable, of, Subject} from 'rxjs';
import {IConnectionFinished, IConnectionState, IConnectionStatus, ILongPollingItem, TFDEStatus} from './interface';
import {environment} from '@env/environment';
import {map} from 'rxjs/operators';

const FDE_LONG_POLLING_FIELD = 'fde-long-polling-data';

@Injectable({
  providedIn: 'root'
})
export class FdeLongPollingService {
  // event emitter when connection selected, refreshed or edited
  connectionEngaged: EventEmitter<number> = new EventEmitter<number>();
  // event to update state (status) in connections list
  connectionStateChanged: EventEmitter<IConnectionState> = new EventEmitter<IConnectionState>();
  // A connection left polling for good. connectionStateChanged can't tell this apart: it maps both a
  // cancelled update and a pending question to WARNING.
  readonly connectionFinished = new Subject<IConnectionFinished>();

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
  ) {
  }

  saveState(connections: number[]) {
    this.localStorageService.setValue(FDE_LONG_POLLING_FIELD, JSON.stringify(connections));
  }

  loadState(): number[] {
    const data = this.localStorageService.getValue(FDE_LONG_POLLING_FIELD);
    if (data) {
      return JSON.parse(data);
    }
    return [];
  }

  selectConnection(connectionId: number) {
    if (!connectionId) {
      return;
    }
    this.connectionEngaged.emit(connectionId);
  }

  updateState(state: IConnectionState) {
    this.connectionStateChanged.emit(state);
  }

  finish(finished: IConnectionFinished) {
    this.connectionFinished.next(finished);
  }

  getConnectionStatus(connectionId: number): Observable<IConnectionStatus> {
    // const messages = [
    //   'Queued. Configuring extractor...',
    //   'Added sub account: Parkway Business Solutions (0123456789)',
    //   'Saving check (№5699) for account (0123456789)',
    //   'Saving check (№4425) for account (0123456789)',
    //   'Extractor successfully logged off',
    // ];
    // @ts-ignore
    // return of({
    //   username: 'sisis',
    //   'lsBankAccountId': 5081,
    //   'fdeAccountResponse': {
    //     statusType: 'FORM_REQUESTED',
    //     metadata: {
    //       type: 'FORM',
    //       form: {
    //         'formFields': [
    //           {
    //             'fieldType': 'MULTISELECT',
    //             'label': 'Select sub accounts to choose from:', //optional, над полем с чекбоксами может быть еще display field type
    //             'mandatory': true,
    //             'save': false,
    //             'formListOptions': [
    //               {
    //                 'key': '8JASDh18',
    //                 'value': 'Sub account 1 (...123)'
    //               },
    //               {
    //                 'key': '1LSKJDLAJ',
    //                 'value': 'Sub account 2 (...234)'
    //               }
    //             ],
    //             msAnswer: ['8JASDh18']
    //           }
    //         ]
    //       }
    //     },
    //     'accountName': 'Premier Finance Card Program',
    //     'accountCode': '8Z7DWGW0YLG533CRMCY3JLTV00TPNLIQ',
    //     //   statusMessage: messages[Math.ceil(Math.random() * 5) - 1],
    //     // statusType:"X" // M for stop
    //     // @ts-ignore
    //     // statusMessage: window.hui ? messages[Math.ceil(Math.random() * 5) - 1] : "Account details updated successfully.",
    //     // @ts-ignore
    //     // 'statusType': 'F',
    //     // 'statusMessage': '{"formFields":[{"type":"formTextField","label":"What is your nickname?","value":null,"answer":null,"fieldType":"TEXT","max":60,"min":1,"mandatory":true,"save":true}]}'
    //   }
    // });
    return this.http.get<IConnectionStatus>(environment.API_URL + `/accounts/${connectionId}`);
  }
}
